import Vue from 'vue'

import './cube-ui'
import App from './App.vue'
import store from './store'
import router from './router'
import VueClipboard from 'vue-clipboard2'
import common from '@/assets/common'
import verify from '@/assets/verify'
import compress from '@/assets/image'
import '@/config'
import '@/assets/less/common.less'
import './plugins/axios'


import api from "@/assets/api";
import message from '@/utils/message'


import codes from '@/utils/returnCode'

import fontawesome from '@fortawesome/fontawesome'
// import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'
import regular from '@fortawesome/fontawesome-free-regular'
import brands from '@fortawesome/fontawesome-free-brands'

fontawesome.library.add(solid)
fontawesome.library.add(regular)
fontawesome.library.add(brands)


Vue.config.productionTip = false

Vue.use(VueClipboard)
Vue.prototype.common = common
Vue.prototype.verify = verify
Vue.prototype.compress = compress 
Vue.prototype.$codes = codes
Vue.prototype.$api = api
Vue.prototype.$message = message

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
